/**
 * English for the white-page pool screen (pages/white-pool). Spread into `en`,
 * so the keys are part of `TKey` and `ru.white.ts` must cover every one.
 */
export const enWhite = {
  "white.nav": "White pool",
  "white.title": "White pool",
  "white.subtitle": "Safe pages that moderation and bots see instead of the offer. Each campaign gets its own; times are Kyiv.",
  "white.port": "Generator",
  "white.port.manual": "ZIP upload only",
  "white.newCell": "Add cell",
  "white.tab.matrix": "Matrix",
  "white.tab.categories": "Categories",
  "white.tab.refills": "Refills",
  "white.sum.fresh": "Fresh",
  "white.sum.consumed": "Used in 7 days",
  "white.sum.low": "Cells below threshold",
  "white.sum.pending": "Campaigns waiting",
  "white.sum.today": "Ordered today",
  "white.sum.todayDetail": "night {night} · day {day} · urgent {urgent}",
  "white.color.enough": "Enough",
  "white.color.tight": "Tight",
  "white.color.low": "Below threshold",
  "white.color.ordered": "Order on the way",
  "white.color.off": "Off",
  "white.matrix.category": "Category",
  "white.matrix.empty.title": "No cells yet",
  "white.matrix.empty.text": "A cell is a category in one country and language. Add one, or create a campaign with an automatic white — it adds its own.",
  "white.matrix.noCategories.title": "Start with a category",
  "white.matrix.noCategories.text": "A category says which offers take its whites (by offer tags) and which generator preset makes them.",
  "white.matrix.add": "Add {geo} / {lang}",
  "white.matrix.cellAria": "{category}, {geo} / {lang}: {fresh} fresh of {target}",
  "white.matrix.pick": "Pick a cell to see its whites, upload a ZIP or refill it.",
  "white.cell.fresh": "fresh",
  "white.cell.target": "target {target} · threshold {threshold}",
  "white.cell.ordered": "+{n} on the way",
  "white.cell.pending": "{n} waiting",
  "white.panel.close": "Close",
  "white.panel.stats.assigned": "In campaigns",
  "white.panel.stats.burned": "Burned",
  "white.panel.stats.consumed": "Used in 7 days",
  "white.panel.stats.pending": "Campaigns waiting",
  "white.panel.targetNote": "The target is recounted every night at 02:00: last week's use per day × 1.5, never below {min}.",
  "white.panel.threshold": "Threshold",
  "white.panel.threshold.hint": "At this many fresh whites or fewer the cell orders more at once. Empty = the category's ({n}).",
  "white.panel.enabled": "Cell is on",
  "white.panel.save": "Save",
  "white.panel.saved": "Cell saved",
  "white.panel.refill": "Refill now",
  "white.panel.refill.manual": "The generator is not connected or the category has no preset — upload a ZIP instead.",
  "white.panel.refilled": "Ordered {n} sites",
  "white.panel.import": "Upload ZIP",
  "white.panel.import.drop": "Drop the site's ZIP here",
  "white.panel.import.hint": "index.html at the root, up to 25 MB. {local} must already be replaced; {domain} becomes the serving domain.",
  "white.panel.import.tooBig": "The ZIP is over 25 MB — make it smaller.",
  "white.panel.imported": "White added to the pool",
  "white.panel.zipOnly": "Only a .zip archive",
  "white.panel.whites": "Whites",
  "white.panel.whites.empty": "No whites here yet.",
  "white.state.all": "All",
  "white.state.fresh": "Fresh",
  "white.state.assigned": "In a campaign",
  "white.state.burned": "Burned",
  "white.white.made": "added {at}",
  "white.white.assigned": "{campaign} since {at}",
  "white.white.burned": "burned {at}: {reason}",
  "white.white.preview": "Preview",
  "white.white.burn": "Burn",
  "white.burn.title": "Burn this white?",
  "white.burn.text": "It is never given out again. A campaign that holds it gets the next fresh white of the cell.",
  "white.burn.reason": "Reason",
  "white.burn.reason.placeholder": "Did not pass moderation…",
  "white.burn.confirm": "Burn",
  "white.burn.cancel": "Cancel",
  "white.burned": "White burned",
  "white.cat.new": "New category",
  "white.cat.edit": "Edit category",
  "white.cat.empty": "No categories yet.",
  "white.cat.col.title": "Category",
  "white.cat.col.tags": "Offer tags",
  "white.cat.col.preset": "Preset",
  "white.cat.col.limits": "Target min / threshold",
  "white.cat.col.contact": "Contact address",
  "white.cat.none": "—",
  "white.cat.off": "Off",
  "white.cat.delete": "Delete",
  "white.cat.delete.title": "Delete category «{title}»?",
  "white.cat.delete.text": "Only a category without whites can be deleted. Its cells go with it.",
  "white.cat.deleted": "Category deleted",
  "white.cat.saved": "Category saved",
  "white.cat.f.title": "Name",
  "white.cat.f.title.placeholder": "Joints…",
  "white.cat.f.key": "Key",
  "white.cat.f.key.hint": "What the cabinet names it by; cannot be changed later.",
  "white.cat.f.tags": "Offer tags",
  "white.cat.f.tags.hint": "A campaign whose offer carries one of these tags takes whites of this category.",
  "white.cat.f.tags.placeholder": "Pick a tag…",
  "white.cat.f.preset": "Generator preset",
  "white.cat.f.preset.none": "No preset — ZIP upload only",
  "white.cat.f.preset.manual": "The generator is not connected: this category takes uploaded ZIPs only.",
  "white.cat.f.targetMin": "Target minimum",
  "white.cat.f.reorderAt": "Threshold",
  "white.cat.f.reorderAt.hint": "Fresh whites at or below which a cell orders more at once.",
  "white.cat.f.contact": "Contact details on the site",
  "white.cat.f.contact.name": "Contact name",
  "white.cat.f.contact.email": "E-mail template",
  "white.cat.f.contact.email.hint": "{local} is filled by the generator, {domain} by the tracker with the serving domain. Shown: {preview}",
  "white.cat.f.contact.host": "Site address",
  "white.cat.f.contact.city": "Show a city address",
  "white.cat.f.contact.form": "Contact form",
  "white.cat.f.contact.noPhone": "No phone number is ever written on a white.",
  "white.cat.f.enabled": "Category is on",
  "white.cat.f.save": "Save",
  "white.cat.f.cancel": "Cancel",
  "white.cat.f.err.key": "Lowercase Latin letters, digits, «_», «-», «.»; starts with a letter or digit",
  "white.cat.f.err.title": "Name the category",
  "white.cat.f.err.range": "From {min} to {max}",
  "white.newCell.title": "Add cell",
  "white.newCell.text": "A category in one country and language. Campaigns of that market take their whites from it.",
  "white.newCell.category": "Category",
  "white.newCell.geo": "Country",
  "white.newCell.lang": "Language",
  "white.newCell.create": "Add",
  "white.newCell.created": "Cell added",
  "white.newCell.err.required": "Required",
  "white.refills.empty": "No orders yet. The first night run is at 02:00.",
  "white.refills.col.at": "Ordered",
  "white.refills.col.cell": "Cell",
  "white.refills.col.kind": "Why",
  "white.refills.col.state": "State",
  "white.refills.col.sites": "Sites: asked / ready / taken",
  "white.refills.col.error": "Problem",
  "white.kind.night": "Night run",
  "white.kind.threshold": "Threshold",
  "white.kind.urgent": "Urgent, for a campaign",
  "white.kind.manual": "Refill now",
  "white.refill.creating": "Being placed",
  "white.refill.open": "Generating",
  "white.refill.done": "Done",
  "white.refill.failed": "Failed",
  "white.refill.cancelled": "Cancelled",
  "white.loadFailed": "Could not load the white pool",
} as const;
